"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAppsOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("circle", { cx: 26, cy: 6, r: 2 }),
        React.createElement("circle", { cx: 16, cy: 6, r: 2 }),
        React.createElement("circle", { cx: 6, cy: 6, r: 2 }),
        React.createElement("circle", { cx: 26, cy: 16, r: 2 }),
        React.createElement("circle", { cx: 16, cy: 16, r: 2 }),
        React.createElement("circle", { cx: 6, cy: 16, r: 2 }),
        React.createElement("circle", { cx: 26, cy: 26, r: 2 }),
        React.createElement("circle", { cx: 16, cy: 26, r: 2 }),
        React.createElement("circle", { cx: 6, cy: 26, r: 2 })));
}
exports.default = SvgAppsOutline;
//# sourceMappingURL=AppsOutline.js.map